import { ControlKeyType, EnumLiteralType } from '../Types';
import BaseViewModel, { BaseViewModelParams } from './BaseViewModel';

class EnumControlViewModel extends BaseViewModel {
	multiflag: boolean;
	selectedValueS2?: any;
	isSave: boolean;
	options: Array<EnumLiteralType>;
	nullTitle?: string;

	constructor(params: BaseViewModelParams) {
		super(params);
		this.multiflag =
			params.elementDescriptor.ControlKey === ControlKeyType.CheckComboBox
				? true
				: false;
		this.isSave = !!params.elementDescriptor.IsSave;
		this.options = params.elementDescriptor.EnumLiterals ?? [];
		this.nullTitle = params.elementDescriptor.NullTitle;

		// для мультивыборов значение по умолчанию — пустой массив, чтобы при сборе данных возвращалось [] если сервер прислал null
		if (this.multiflag && this.selectedValueS2 === undefined) {
			this.selectedValueS2 = [];
		}
	}

	setValue = (value: any) => {
		let val = undefined;
		if (value) {
			if (Array.isArray(value)) {
				val = value.map((v) => {
					return v.toString();
				});
			} else {
				val = value.toString();
			}
		}
		this.selectedValueS2 = val;
		this.Value = val;
	};
	getValue = () => {
		return this.selectedValueS2;
	};

	ValidateMandatory = () => {
		if (!this.IsMandatory) {
			return true;
		}

		// для мультивыборов (CheckComboBox) обязательность считаем по длине массива
		if (this.multiflag) {
			const v = this.selectedValueS2;
			return Array.isArray(v) && v.length > 0;
		}

		return (
			!!this.Value ||
			(this.selectedValueS2 !== undefined &&
				this.selectedValueS2 !== null)
		);
	};
}

export default EnumControlViewModel;
